import styles from './style.module.scss';
import { Descriptions } from 'antd';
import { PageHeader } from 'components';
import { useTranslation } from 'react-i18next';
import useVacancies from '../useVacancies';
import moment from 'moment';

const Single = ({}) => {
  const { t } = useTranslation();
  const { singleItem } = useVacancies(false);
  const title = t('Annunci');

  return (
    <div>
      <PageHeader title={title} />
      <div className={styles.content}>
        <Descriptions column={1} bordered>
          <Descriptions.Item label={t('Village')}>
            {singleItem?.shopping_center || singleItem?.shopping_center_title}
          </Descriptions.Item>
          <Descriptions.Item label={t('Insegna')}>
            {singleItem?.company_name}
          </Descriptions.Item>
          <Descriptions.Item label={t('Settore')}>
            {singleItem?.vacancy_application_type}
          </Descriptions.Item>
          <Descriptions.Item label={t('Titolo')}>
            {singleItem?.title}
          </Descriptions.Item>
          <Descriptions.Item label={t('Data Pubblicazione')}>
            {moment(singleItem?.created_at).format('DD MMMM YYYY')}
          </Descriptions.Item>
          <Descriptions.Item label={t('Data scadenza')}>
            {moment(singleItem?.expired_at, 'YYYY-MM-DD').format(
              'DD MMMM YYYY',
            )}
          </Descriptions.Item>
          <Descriptions.Item label={t('Descrizione')}>
            {singleItem?.description}
          </Descriptions.Item>
        </Descriptions>
        {singleItem?.vacancy_fields && singleItem?.vacancy_fields.length > 0 && (
          <>
            <h1 className={styles.subheader}>{t('Informazioni aggiuntive')}</h1>
            <Descriptions column={1} bordered>
              {singleItem?.vacancy_fields.map((field) => (
                <Descriptions.Item label={field.title}>
                  {field.vacancy_field_values &&
                  field.vacancy_field_values.length ? (
                    <ul>
                      {field.vacancy_field_values.map((value) => (
                        <li>{value.title}</li>
                      ))}
                    </ul>
                  ) : (
                    ' '
                  )}
                </Descriptions.Item>
              ))}
            </Descriptions>
          </>
        )}
      </div>
    </div>
  );
};

export default Single;
